export default __webpack_public_path__ + "static/media/cube3.0cb72395.png";